import { render, staticRenderFns } from "./DaisoStaticImage.vue?vue&type=template&id=b44c79d6&"
import script from "./DaisoStaticImage.vue?vue&type=script&lang=js&"
export * from "./DaisoStaticImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports